import { Data } from ".."
import { normalizeString } from "../../functions"
import formatDate from "../formatDate"
import getCurrency from "../getCurrency"

const DataExpense = ({
	expense,
	patients,
	providers,
	bankAccounts
}) => {
	const {
		id,
		contributedAmount,
		createdTs,
		allocatedAmount,
		amount,
		serviceDate,
		description,
		review
	} = expense
	const unallocatedAmount = amount - allocatedAmount

	const date = new Date(`${serviceDate}T00:00:00`)

	const provider = providers?.size ? providers.get(expense.providerId) : null
	let patient = patients?.size ? patients.get(expense.patientId) : null

	patient = patient?.id ? Data.Dependent({ dependent: patients.get(expense.patientId) }) : null

	const planType = expense.allocations.length > 0 ? expense.allocations[0]?.plan?.type : ""

	return {
		...expense,
		contributedAmount,
		provider,
		patient,
		date,
		dateOfServiceTs: formatDate({
			data: serviceDate,
			actions: ["ts"],
			options: ["append-timezone"],
			defaultReturn: ""
		}),
		dateFormated: formatDate({
			actions: ["display"],
			options: ["append-timezone"],
			data: serviceDate
		}),

		randomNum: 2,
		targetAccount: bankAccounts?.size
			? bankAccounts.get(expense.targetAccount)
			: expense.targetAccount,
		tableGroup:
			expense.status === "readyToProcess" || expense.status === "notReadyToProcess"
				? "pending"
				: "unallocated",
		unallocatedAmount,
		tableValues: {
			plan: planType,
			description,
			tableGroup:
				expense.status === "readyToProcess" || expense.status === "notReadyToProcess"
					? "pending"
					: "unallocated",
			date: serviceDate ? formatDate({ data: date, actions: ["display"], defaultReturn: "" }) : "",
			createdDate: formatDate({ data: createdTs, actions: ["display"] }),
			provider: provider?.displayName || "",
			patient: patient?.fullName || "",
			unallocatedAmount: unallocatedAmount
				? getCurrency({
						amount: unallocatedAmount,
						actions: ["divide"]
				  })
				: "",
			amount: getCurrency({
				amount: expense.amount,
				actions: ["divide"]
			}),

			// Approved, On Hold, Rejected,
			hraStatus:
				planType?.includes("HRA") || planType?.includes("FSA")
					? normalizeString({
							data: review?.status?.short,
							actions: ["capitalize"]
					  })
					: "",

			labels: {
				hraStatus: expense.hraStatus ? "HRA Status:" : "",
				reimbursedAmount: expense.hraStatus ? "Reimbursed Amount:" : "",
				unallocatedAmount: unallocatedAmount ? "Unallocated Amount:" : "",
				createdDate: "Transaction Date:"
			},
			hraType: expense.amount > 0 ? "Contribution" : "Reimbursement",
			reimbursedAmount:
				planType?.includes("HRA") || planType?.includes("FSA")
					? getCurrency({
							amount: expense?.hraReimbursement?.reimbursedAmount,
							actions: ["divide"],
							defaultReturn: " "
					  })
					: ""
		}
	}
}

export default DataExpense
